import { Component, HostListener, OnInit } from '@angular/core';
import { ItemMenuService } from '../../services/item-menu.service';
import { InitializationService } from '../../services/initialization.service';
import { CurrentOrderService } from '../../services/current-order.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-item-added',
  templateUrl: './item-added.component.html',
  styleUrls: ['./item-added.component.scss']
})
export class ItemAddedComponent implements OnInit 
{
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) 
  {
    $event.returnValue =true;
  }

  lastItem:any;

  constructor
  (
    private initializationservice:InitializationService, 
    private route: ActivatedRoute, 
    private router:Router, 
    private currentorderservice:CurrentOrderService,
    private navigationservice:NavigationService
  ) {}

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
     this.initializationservice.reloadApp(appname);

      return;
    }

    this.lastItem = this.currentorderservice.getLastAddedItem();
  }

  keepBuying()
  {
    this.navigationservice.back();
  }

  finishOrder()
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    this.router.navigateByUrl('/' + appname + '/currentorder', { replaceUrl : true });
  }
}
